import request from "@/utils/request";

// 查询留言列表
export function getMessageList(params) {
  return request({
    url: "/admin/messages",
    method: "get",
    params: params
  });
}

//删除留言
export function removeMessage(data) {
  return request({
    url: "/admin/messages",
    method: "delete",
    data: data
  });
}
